import { TouchableOpacity, View } from "react-native";
import CustomText from "../accessories/CustomText";
import { android, ios, web } from "../accessories/Platform";
import Icon from "react-native-vector-icons/FontAwesome";
import AntDesign from "react-native-vector-icons/AntDesign";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import { useState, Fragment } from "react";
import { getKeyByValue, isFloat } from "../accessories/CommonFunctions";
import { Dimensions } from "react-native";

let isSmallScreen =
  (web && window.innerWidth > 900) ||
  Dimensions.get("window").width > 900 ||
  !web;

let isMobileWeb = Dimensions.get("window").width <= 480;

const navOption = [
  {
    Name: "Summary Info",
    Status: false,
    Id: 10,
    isExpand: false,
    hasSubMenu: true,
    index: 0,
  },
  {
    Name: "Borrower Info",
    Status: false,
    Id: 1,
    isExpand: false,
    hasSubMenu: true,
    index: 1,
  },
  {
    Name: "Verify Bank Accounts",
    Status: false,
    Id: 12,
    isExpand: false,
    hasSubMenu: false,
    index: 2,
  },
  {
    Name: "Bank Accounts",
    Status: false,
    Id: 5,
    isExpand: false,
    hasSubMenu: true,
    index: 3,
  },
  {
    Name: "Address History",
    Status: false,
    Id: 3,
    isExpand: false,
    hasSubMenu: true,
    index: 4,
  },
  {
    Name: "Credit Scores",
    Status: false,
    Id: 2,
    isExpand: false,
    hasSubMenu: true,
    index: 5,
  },
  {
    Name: "Employment",
    Status: false,
    Id: 4,
    isExpand: false,
    hasSubMenu: true,
    index: 6,
  },
  {
    Name: "Real Estate Owned",
    Status: false,
    Id: 13,
    isExpand: false,
    hasSubMenu: true,
    index: 7,
  },
  {
    Name: "Government",
    Status: false,
    Id: 6,
    isExpand: false,
    hasSubMenu: true,
    expandIndex: [0],
    index: 8,
  },
  {
    Name: "Document Upload",
    Status: false,
    Id: 9,
    index: 9,
  },
  {
    Name: "eSign",
    Status: false,
    Id: 7,
    index: 10,
  },
  {
    Name: "Appraisal Payment",
    Status: false,
    Id: 8,
    index: 11,
  },
  {
    Name: "Review Your Interest Rate",
    Status: false,
    Id: 11,
    index: 12,
  },
  {
    Name: "Completed",
    Status: false,
    Id: 14,
    index: 13,
  },
];

const navOptionEsign = [
  {
    Name: "eSign Instructions",
    Status: false,
    Id: 20,
    index: 20,
  },
  {
    Name: "Signing Font",
    Status: false,
    Id: 21,
    index: 21,
  },
  {
    Name: "eSign Consent Agreement",
    Status: false,
    Id: 22,
    index: 22,
  },
  {
    Name: "Remove eSign Consent",
    Status: false,
    Id: 23,
    index: 23,
  },
  {
    Name: "Change My Email Address",
    Status: false,
    Id: 24,
    index: 24,
  },
  {
    Name: "Cancel eSign Package",
    Status: false,
    Id: 25,
    index: 25,
  },

  {
    Name: "View Signing Status", //"View Other's Signing Status",
    Status: false,
    Id: 26,
    index: 26,
  },
  {
    Name: "View More Packages",
    Status: false,
    Id: 27,
    index: 27,
  },
];

const iPageArray = [
  "summaryInfo",
  "borrowerInfo",
  "borrowerVerification",
  "bankAccounts",
  "addressHistory",
  "creditScore",
  "employment",
  "realEstateOwned",
  "government",
  "documentUpload",
  "eSign",
  "appraisalPayment",
  "reviewYourInterestRate",
  "completed",
];
const iPageIdObj = {
  summaryInfo: 0,
  borrowerInfo: 1,
  borrowerVerification: 2,
  bankAccounts: 3,
  addressHistory: 4,
  creditScore: 5,
  income: 6,
  realEstateOwned: 7,
  government: 8,
  documentUpload: 9,
  eSign: 10,
  appraisalPayment: 11,
  reviewYourInterestRate: 12,
  completed: 13,
};

const iActivePageArray = [
  "Summary Info",
  "Borrower Info",
  "Verify Bank Accounts",
  "Bank Accounts",
  "Address History",
  "Credit Scores",
  "Employment",
  "Real Estate Owned",
  "Government",
  "Document Upload",
  "eSign",
  "Appraisal Payment",
  "Review Your Interest Rate",
  "Completed",
];

const handleProcessNavOptions = (
  navOptions,
  pageIndex,
  additionalEmploymentList,
  pageId = null
) => {
  const pageIdObj = pageId || iPageIdObj;
  return navOptions.map((item, index) => {
    item["isExpand"] = index == pageIndex["page"];
    item["expandIndex"] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

    if (pageIndex["page"] === 5 && index === 5) {
      let val = [0];
      additionalEmploymentList.map((iItem, iIndex) => {
        if (iItem["subMenu"]) {
          iItem["subMenu"].map((jItem, jIndex) => {
            if (jItem["index"] === pageIndex["subPage"]) {
              val = [iIndex];
            }
          });
        } else if (iItem["index"] === pageIndex["subPage"]) {
          val = [iIndex];
        }
      });
      item["expandIndex"] = val || [0];
    }
    return item;
  });
};

const handleManipulateNavOptions = (isESignOnly, excludePageIds) => {
  let iNavLeftOptionState = navOption;
  if (isESignOnly) {
    iNavLeftOptionState = [];
  }
  if (excludePageIds.length) {
    iNavLeftOptionState = iNavLeftOptionState.filter(
      (item) => !excludePageIds.includes(parseInt(item["Id"]))
    );
  }

  return iNavLeftOptionState;
};

const NavBarContent = (props) => {
  let platformType = "";
  if (android) {
    platformType = "android";
  } else if (ios) {
    platformType = "ios";
  } else if (isMobileWeb) {
    platformType = "isMobileWeb";
  } else if (web) {
    platformType = "web";
  } else platformType = "";

  const {
    navLeftOption = [],
    additionalBorrowerList = [],
    additionalEmploymentList = [],
    additionalBankList = [],
    creditPageList = [],
    summaryInfoList = [],
    realEstateList = [],
    additionalAddressHistoryList = [],
    governmentPageList = [
      { Name: "Declarations" },
      { Name: "Demographic" },
      { Name: "VA Section" },
      { Name: "Counseling Seminar" },
    ],
    preventNavigation,
    isHome,
    currentPage = "",
    setCurrentPage = () => {},
    pageIndex = { page: 0, subPage: 0 },
    completedPage,
    loanId,
    handleNavigateSubPage,
    handleActiveTab,
    setNavLeftOptionState = () => {},
    navLeftOptionState = [],
    navigate = () => {},
    handleClearState = () => {},
    isDashBoard,
    progressPercentage = 0,
    webviewRef,
    setNavOpen = () => {},
    iFrameviewRef,
    pageId,
    activePageArray = iActivePageArray || [],
    inCompletedSubPageObj = {},
    isLoaded,
  } = props;
  const pageIdObj = pageId || iPageIdObj;

  return (
    <>
      {navLeftOption.map((item, index) => {
        let iAdditionalBorrowerList = JSON.parse(
            JSON.stringify(additionalBorrowerList)
          ),
          subMenuArray = isHome
            ? item["Id"] === 4
              ? additionalEmploymentList
              : item["Id"] === 5
              ? additionalBankList
              : item["Id"] === 2
              ? creditPageList
              : item["Id"] === 10
              ? summaryInfoList
              : item["Id"] === 13
              ? realEstateList
              : item["Id"] === 6
              ? iAdditionalBorrowerList.map((item) => {
                  item["subMenu"] = JSON.parse(
                    JSON.stringify(governmentPageList)
                  );
                  return item;
                })
              : item["Id"] === 3
              ? additionalAddressHistoryList
              : additionalBorrowerList
            : [],
          isDisable = (index > 1 && loanId < 0) || preventNavigation;
        let { isExpand } = item;
        if (!isLoaded && item["Id"] === 10) {
          isExpand = false;
        }

        if (isHome && item["Id"] === 1) {
          subMenuArray = subMenuArray.filter(
            (item) => item["Name"] !== "Additional Borrowers"
          );
          subMenuArray.push({ Name: "Additional Borrowers" });
        }
        let zIndex = 0;
        subMenuArray.map((xItem, xIndex, arr) => {
          if (xItem["subMenu"]) {
            xItem["subMenu"].map((yItem, yIndex) => {
              yItem["index"] = zIndex;
              zIndex++;
              delete xItem["index"];
            });
          } else {
            xItem["index"] = zIndex;
            zIndex++;
          }
        });

        const activePage =
            item["Name"] === activePageArray[pageIdObj[currentPage]],
          inCompleteTabIndex =
            inCompletedSubPageObj[getKeyByValue(pageIdObj, item["index"])] ||
            [];

        return (
          <TouchableOpacity
            activeOpacity={1}
            key={index}
            style={[
              {
                paddingVertical: !isSmallScreen ? 18 : 13,
                paddingHorizontal: !isSmallScreen ? 18 : 15,

                ...{
                  borderBottomWidth: 2,
                  borderBottomColor: "#d9d9d9",
                },
                ...(web ? { cursor: "pointer" } : {}),
              },
              item["Name"] === "My Dashboard"
                ? { paddingBottom: web ? 35 : 25 }
                : {},
              {
                display:
                  item["Name"] !== "My Dashboard" && index !== 1 && isDisable
                    ? "none"
                    : "flex",
              },
              // { backgroundColor: "red" },
            ]}
          >
            <CustomText
              style={{
                fontSize: 17,
                width: "100%",
              }}
              onPress={() => {
                if (item["Name"] === "My Dashboard") {
                  setNavLeftOptionState([
                    ...(navLeftOptionState || navOption).map((nav) => {
                      nav["isExpand"] = false;
                      return nav;
                    }),
                  ]);
                  navigate("DashBoard");
                  handleClearState(isDashBoard);
                } else if (!preventNavigation && !isDisable) {
                  //add esign on press here
                  if (
                    [20, 21, 22, 23, 24, 25, 26, 27].includes(
                      Number(item["Id"])
                    )
                  ) {
                    try {
                      const functionName = "InvokeEsignMenu";
                      const scriptToInject = `window.${functionName}(${item["Id"]});`;
                      webviewRef.current.injectJavaScript(scriptToInject);
                    } catch (e) {
                      const iframeWindow = iFrameviewRef.current.contentWindow;
                      if (iframeWindow)
                        iframeWindow.InvokeEsignMenu(item["Id"]);
                    }

                    setNavOpen({ left: false, right: false });
                  } else {
                    setCurrentPage(item["Name"]);
                    handleActiveTab(index);
                  }
                }
              }}
            >
              {/* Main-Menu */}
              <View
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  width: android ? 260 : "100%",
                  marginBottom: web ? "auto" : -5,
                }}
              >
                {item["Name"] === "My Dashboard" ? (
                  <Icon size={22} name="home" />
                ) : (
                  <>
                    {currentPage !== "eSign" &&
                      ![20, 21, 22, 23, 24, 25, 26, 27].includes(
                        Number(item["Id"])
                      ) && (
                        <AntDesign
                          testID="statusIcon"
                          style={{ alignSelf: "center" }}
                          size={web ? 22 : 20}
                          name={item["Status"] ? "check" : "close"}
                          color={
                            !completedPage || item["Id"] == 14
                              ? "#fff"
                              : item["Status"]
                              ? "#247c00"
                              : "#d60000"
                          }
                        />
                      )}
                  </>
                )}
                <CustomText
                  bold={activePage}
                  style={{
                    color: "black",
                    alignSelf: "center",
                    fontSize: 17,
                  }}
                >
                  {"  "}
                  {item["Name"]}
                  {item["Id"] == 14 && <> {progressPercentage}%</>}
                </CustomText>
                <View
                  style={{
                    alignSelf: "flex-end",
                    marginLeft: "auto",
                  }}
                >
                  <MaterialCommunityIcons
                    size={26}
                    name={isExpand ? "chevron-down" : "chevron-right"}
                    color={
                      item["hasSubMenu"] && subMenuArray.length > 0
                        ? "#1c1a1e"
                        : "#fff"
                    }
                    onPress={() => {
                      // setCurrentPage(item["Name"]);
                      // handleActiveTab(index);
                      setNavLeftOptionState([
                        ...(navLeftOptionState || navOption).map(
                          (nav, nIndex) => {
                            if (nIndex === index - 1)
                              nav["isExpand"] = !nav["isExpand"];
                            return nav;
                          }
                        ),
                      ]);
                    }}
                  />
                </View>
              </View>
            </CustomText>
            {/* Sub-Menu */}
            {item["hasSubMenu"] && isExpand && (
              <View
                style={{
                  borderRadius: 5,
                  marginVertical: 5,
                }}
              >
                {subMenuArray.map((iItem, iIndex, arr) => {
                  let iSubPage = [8].includes(pageIndex["page"])
                      ? pageIndex["subPage"] / 4
                      : pageIndex["subPage"],
                    active =
                      item["Id"] !== 4
                        ? arr.indexOf(iItem) == parseInt(iSubPage) &&
                          pageIndex["page"] + 1 === index
                        : !iItem["subMenu"] && item["Id"] == 4
                        ? iItem["index"] == parseInt(iSubPage)
                        : false,
                    isDisable =
                      (loanId < 0 &&
                        index === 1 &&
                        iIndex >
                          arr.findIndex(
                            (item) => item.Name === "Loan Officers"
                          )) ||
                      preventNavigation;

                  return (
                    <Fragment key={iIndex}>
                      <CustomText
                        style={{
                          ...{
                            fontSize: 16,
                            paddingVertical: web ? 10 : 5,
                            paddingLeft: 40,
                            marginLeft: iItem["subMenu"] ? 20 : 0,
                            color:
                              [pageIdObj["employment"]].includes(
                                pageIndex["page"]
                              ) &&
                              (iItem["subMenu"] || []).length === 0 &&
                              Array.isArray(inCompleteTabIndex[0]) &&
                              inCompleteTabIndex[0]?.includes(iItem["index"])
                                ? "red"
                                : ![
                                    pageIdObj["government"],
                                    pageIdObj["employment"],
                                    pageIdObj["addressHistory"],
                                  ].includes(pageIndex["page"]) &&
                                  inCompleteTabIndex.includes(iIndex)
                                ? "red"
                                : "black",
                            opacity: iIndex > 0 && isDisable ? 0.5 : 1,
                            display:
                              iIndex > (preventNavigation ? 2 : 3) && isDisable
                                ? "none"
                                : "flex",
                            overflow: "hidden",
                          },
                          ...(web ? { cursor: "pointer" } : {}),
                        }}
                        onPress={() => {
                          if (!isDisable && ![6, 4].includes(item["Id"])) {
                            if ((iItem["subMenu"] || []).length > 0) {
                              let iNavLeftOptionState = navLeftOptionState,
                                arr = iNavLeftOptionState[index - 1];
                              if (!arr["expandIndex"]) arr["expandIndex"] = [];
                              if (arr["expandIndex"].includes(iIndex))
                                arr["expandIndex"] = arr["expandIndex"].filter(
                                  (i) => i !== iIndex
                                );
                              else arr["expandIndex"].push(iIndex);

                              arr["expandIndex"] = [
                                ...new Set(arr["expandIndex"]),
                              ];
                              iNavLeftOptionState[index - 1] = arr;
                              setNavLeftOptionState([
                                ...[],
                                ...iNavLeftOptionState,
                              ]);
                            } else if (!preventNavigation) {
                              handleNavigateSubPage(index - 1, iItem["index"]);
                            }
                          }
                        }}
                        bold={
                          activePage &&
                          active &&
                          (iItem["subMenu"] || []).length === 0
                        }
                      >
                        {(iItem["subMenu"] || []).length > 0 && (
                          <MaterialCommunityIcons
                            size={20}
                            name={
                              (item["expandIndex"] || [0]).includes(iIndex) ||
                              active
                                ? "chevron-down"
                                : "chevron-right"
                            }
                          />
                        )}
                        {iItem["Name"]}
                      </CustomText>
                      {iItem["subMenu"] &&
                        ((item["expandIndex"] || [0]).includes(iIndex) ||
                          active) && (
                          <View
                            style={{
                              borderRadius: 5,
                              marginLeft: 15,
                              marginRight: 10,
                              marginTop: 5,
                            }}
                          >
                            {iItem["subMenu"].map((jItem, jIndex) => {
                              return (
                                <CustomText
                                  key={jIndex}
                                  bold={
                                    activePage &&
                                    jItem["index"] === pageIndex["subPage"]
                                  }
                                  style={{
                                    ...{
                                      fontSize: web ? 16 : 15,
                                      paddingVertical: 5,
                                      paddingLeft: 45,
                                      marginLeft: 25,
                                      marginBottom: 5,
                                      color:
                                        ([pageIdObj["employment"]].includes(
                                          pageIndex["page"]
                                        ) &&
                                          Array.isArray(
                                            inCompleteTabIndex[1]
                                          ) &&
                                          inCompleteTabIndex[1]?.includes(
                                            jItem["index"]
                                          )) ||
                                        ([
                                          pageIdObj["government"],
                                          pageIdObj["addressHistory"],
                                        ].includes(pageIndex["page"]) &&
                                          inCompleteTabIndex.includes(
                                            jItem["index"]
                                          ))
                                          ? "red"
                                          : "black",

                                      overflow: "hidden",
                                    },
                                    ...(web ? { cursor: "pointer" } : {}),
                                  }}
                                  onPress={() => {
                                    !preventNavigation &&
                                      handleNavigateSubPage(
                                        index - 1,
                                        jItem["index"]
                                      );
                                  }}
                                >
                                  {jItem["Name"]}
                                </CustomText>
                              );
                            })}
                          </View>
                        )}
                    </Fragment>
                  );
                })}
              </View>
            )}
          </TouchableOpacity>
        );
      })}
    </>
  );
};

// NavBarContent.defaultProps = {
//   currentPage: "", // Default value for currentPage
// };

export {
  navOption,
  handleProcessNavOptions,
  handleManipulateNavOptions,
  NavBarContent,
  iPageArray,
  iPageIdObj,
  iActivePageArray,
  navOptionEsign,
};
